export default __webpack_public_path__ + "static/media/marke_5.331437d9.png";